import { Button, Col, Input, Modal, QRCode, Row, Typography } from "antd";
import "./userTotpEnableModal.scss";
import React, { useEffect, useState } from "react";
import { HandleErrors } from "../../utils/handleErrors";
import { toast } from "react-toastify";
import {
  userEnableTotpCodeService,
  userGenerateTotpCodeService,
} from "../../services/user.service";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { GetMeRes } from "../../interfaces/user.interface";

interface Props {
  show: boolean;
  onClose: () => void;
}

export const UserTotpEnableModal: React.FC<Props> = (props) => {
  const user = useSelector<RootState, GetMeRes>((root) => root.user);

  const [show, setShow] = useState(false);

  const [step, setStep] = useState(1);

  const [loading, setLoading] = useState(false);

  const [code, setCode] = useState("");
  const [verifyCode, setVerifyCode] = useState("");

  useEffect(() => {
    setShow(props.show);
    if(props.show){
      setVerifyCode("")
      setStep(1)
    }
  }, [props.show]);

  useEffect(() => {        
    if (!user.totp_enable) {
      generateTotp();
    }
  }, [user.totp_enable]);

  const generateTotp = async () => {
    try {
      setLoading(true);
      const res = await userGenerateTotpCodeService({});
      setCode(res.otpauth_url);
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  const enableTotp = async () => {
    try {
      setLoading(true);
      const res = await userEnableTotpCodeService({
        totp: verifyCode,
      });
      setLoading(false);
      setShow(false);
      props.onClose();
      toast.success("ورود دومرحله‌ای با موفقیت فعال شد");
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="UserTotpEnableModal">
      <Modal
        destroyOnClose={true}
        title={"تنظیم Authenticator"}
        onCancel={() => {
          setShow(false);
          props.onClose();
        }}
        open={show}
        footer={null}
        width={550}
      >
        <div className="UserTotpEnableModalContent">
          {step == 1 && (
            <div className="step1">
              <Row justify={"space-between"} align={"top"}>
                <Col xs={11}>
                  <Row>
                    <Typography.Text className="title">
                      تنظیم به وسیله QR Code
                    </Typography.Text>
                  </Row>
                  <Row>
                    <Typography.Text className="desc">
                      کد QR رو به رو را با برنامه authenticator خود اسکن کنید
                    </Typography.Text>
                  </Row>
                </Col>
                <Col xs={10} className="qr-box">
                  <QRCode className="qr" value={code} />
                </Col>
              </Row>
              <Row
                justify={"space-between"}
                align={"middle"}
                style={{
                  marginTop: 20,
                }}
              >
                <Col xs={11}>
                  <Button
                    onClick={() => {
                      setStep(2);
                    }}
                    block
                    type="primary"
                    className="btn"
                  >
                    ادامه
                  </Button>
                </Col>
                <Col xs={11}>
                  <Button
                    onClick={() => {
                      props.onClose();
                      setShow(false);
                    }}
                    block
                    className="btn"
                  >
                    بازگشت
                  </Button>
                </Col>
              </Row>
            </div>
          )}
          {step == 2 && (
            <div className="step2">
              <Row>
                <Typography.Text className="title">
                  کد ۶ رقمی ساخته شده توسط برنامه Authenticator را وارد کنید
                </Typography.Text>
              </Row>
              <Row>
                <Col xs={24}>
                  <Input.OTP
                    value={verifyCode}
                    onChange={(e) => {
                      setVerifyCode(e);
                    }}
                  />
                </Col>
              </Row>
              <Row
                justify={"space-between"}
                align={"middle"}
                style={{
                  marginTop: 20,
                }}
              >
                <Col xs={11}>
                  <Button
                    onClick={enableTotp}
                    block
                    type="primary"
                    className="btn"
                    loading={loading}
                  >
                    تایید
                  </Button>
                </Col>
                <Col xs={11}>
                  <Button
                    onClick={() => {
                      setStep(1);
                    }}
                    block
                    className="btn"
                  >
                    بازگشت
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};
